<template lang='pug'>
#app
  svg-sprite
  router-view
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';

import SvgSprite from '@/components/SvgSprite.vue';
import { useIframeHeightSync } from '@/composables/useIframeHeightSync';

export default defineComponent({
  name: 'App',
  components: { SvgSprite },
  setup() {
    useIframeHeightSync();
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      appObj: '',
      appInit: false,
    };
  },
  computed: {
    ...mapGetters('users', ['me', 'isMeSignedIn']),
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  created() {
    this.setMe();
  },

  methods: {
    ...mapActions('users', ['setMe', 'resetMe', 'setMeIsSignedIn']),
  },
});
</script>

<style lang='scss'>
@import './assets/styles/plugins';
@import './assets/styles/main';

// Embedded iframe: parent page handles scrolling; child reports height via postMessage
html.spotlight-embedded,
html.spotlight-embedded body {
  overflow: hidden !important;
  height: auto !important;
}

html.spotlight-embedded .web-app-container .main-content_inner-wrap,
html.spotlight-embedded .main-content_inner-wrap,
html.spotlight-embedded .web-app-menu {
  min-height: 0 !important;
}

html.spotlight-embedded .payment-layout-wrapper {
  min-height: 0 !important;
}

// In embeds, use in-flow footer so iframe height matches content (no fixed-position gap)
html.spotlight-embedded .payment-fixed-footer,
html.spotlight-embedded .checkout-footer,
html.spotlight-embedded .action-buttons-fixed {
  position: static !important;
  transform: none !important;
  max-width: 100% !important;
  width: 100% !important;
  left: auto !important;
  right: auto !important;
  box-shadow: none !important;
}

html.spotlight-embedded .webStickerBody,
html.spotlight-embedded .profile-container {
  overflow: hidden;
}

html.spotlight-embedded .payment-footer-spacer {
  display: none !important;
}

html.spotlight-embedded .ticket-checkout-page,
html.spotlight-embedded .ticket-success-page {
  min-height: 0 !important;
}

html.spotlight-embedded .ticket-checkout-page.has-checkout-footer {
  padding-bottom: 1.5rem !important;
}

html.spotlight-embedded .ticket-success-page {
  padding-bottom: 1.5rem !important;
}

// Embed: no dimmed backdrop on dialogs/modals (iframe content stays visible behind)
html.spotlight-embedded {
  --el-overlay-color-lighter: transparent;
  --el-overlay-color: transparent;
  --el-mask-color: transparent;
  --el-mask-color-extra-light: transparent;
}

html.spotlight-embedded .el-overlay,
html.spotlight-embedded .el-overlay-dialog,
html.spotlight-embedded .el-message-box__overlay {
  background-color: transparent !important;
}

html.spotlight-embedded .success-dialog-backdrop,
html.spotlight-embedded .donation-dialog-backdrop,
html.spotlight-embedded .donation-bottom-sheet-backdrop,
html.spotlight-embedded .sticker-bottom-sheet-backdrop,
html.spotlight-embedded .sticker-purchase-bottom-sheet-backdrop {
  background-color: transparent !important;
}
</style>
